

    <dashlet-table [columns]="columns" [dataSource]="tableData" [tableHeightRows]="height" [pagination]="true" [pageLength]="height - 1"></dashlet-table>

